import React from 'react';
import { Input } from 'antd';
import { useFieldController } from '../../../helpers/formManager';
import FormFieldItem from './FormFieldItem';
import { fieldNames } from '../constants';
import styles from '../index.module.scss';

const fieldsConfig = [
  {
    name: fieldNames.surName,
    label: 'Фамилия',
    placeholder: 'Иванов',
    rules: {
      validate: (value) => Boolean(value?.trim()) || 'Укажите фамилию',
    },
  },
  { name: fieldNames.firstName, label: 'Имя', placeholder: 'Иван' },
  { name: fieldNames.patrName, label: 'Отчество', placeholder: 'Иванович' },
];

const NameFields = ({ control, disabled }) => (
  <div className={styles.nameFieldsRow}>
    {fieldsConfig.map((config) => (
      <NameField
        key={config.name}
        control={control}
        disabled={disabled}
        {...config}
      />
    ))}
  </div>
);

export default NameFields;

function NameField({ control, name, label, placeholder, rules, disabled }) {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useFieldController({ control, name, rules });

  return (
    <FormFieldItem
      label={label}
      required={Boolean(rules)}
      errorMessage={error?.message}
    >
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled && Boolean(value?.trim())}
      />
    </FormFieldItem>
  );
}
